import React, { useState } from 'react';
import HrHeader from "../../HrPanel/HrHeader";
import HrSidebar from "../../HrPanel/HrSideBar";
import HackathonEventDetails from './HackathonEventDetails';
//import EventDetails from './EventDetails';
//import EventParticipantsDetails from '../Participants/EventParticipantsDetails';
//import EventCertificate from '../Certificates/EventCertificate';


const Hackathonhr = () => {
  const [activeTab, setActiveTab] = useState('hackathonDetails');
  const [isTeam, setIsTeam] = useState(true);

  return (
    <div className="flex flex-row w-full bg-[#090119]">
      <HrHeader dashboardName="Hackathon Registered details" />
      <HrSidebar />
      <div className="md:flex-1 md:ml-8 px-4 pt-24 pl-60">
        <div className="text-white">


          <div className="flex w-full justify-center space-x-2 bg-[#0a0017] py-2 rounded-xl">
            {/* Hackathon Details */}
            <button
              className={`flex-1 h-[50px] text-xl rounded-l-2xl ${activeTab === 'hackathonDetails' ? 'bg-gray-300 text-black' : 'bg-violet-900 text-white'
                }`}
              onClick={() => setActiveTab('hackathonDetails')}
            >
              Hackathon Details
            </button>

            {/* Hack Reg Participant Details + Team/Single Toggle */}
            <div className="flex items-center flex-1 h-[50px] justify-center relative">
              <button
                className={`h-full w-full text-xl ${activeTab === 'participantsDetails' ? 'bg-white text-black' : 'bg-violet-900 text-white'
                  }`}
                onClick={() => setActiveTab('participantsDetails')}
              >
                Hack Reg Participant Details
              </button>
              <button
                className={`ml-2 absolute right-3 top-1/2 -translate-y-1/2 px-2 py-1 text-sm font-semibold ${activeTab === 'participantsDetails' ? 'bg-violet-900 text-white' : 'bg-gray-300 text-black'
                  } rounded-full`}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsTeam(!isTeam);
                }}
              >
                {isTeam ? 'Team' : 'Single'}
              </button>
            </div>

            {/* Certificates */}
            <button
              className={`flex-1 h-[50px] text-xl rounded-r-2xl ${activeTab === 'certificates' ? 'bg-gray-300 text-black' : 'bg-violet-900 text-white'
                }`}
              onClick={() => setActiveTab('certificates')}
            >
              Hackathon Certificates
            </button>
          </div>


          {activeTab === 'hackathonDetails' && <HackathonEventDetails />}
          {/* {activeTab === 'participantsDetails' && <EventParticipantsDetails />}
          {activeTab === 'certificates' && <EventCertificate />} */}
        </div>
      </div>
    </div>
  );
};

export default Hackathonhr;
